import {
  BaseSavedSearch,
  MarketSavedSearchDto,
  SavedSearchInput,
  NotificationChannels,
} from "../model/model";
import { RestClient } from "./RestClient";
import { SavedSearchClient } from "../model/SavedSearchClient";
import { MarketMapper } from "../mappers/MarketMapper";

export class MarketSavedSearchClient implements SavedSearchClient {
  private client: RestClient<MarketSavedSearchDto>;

  constructor() {
    this.client = new RestClient("/api/saved-search");
  }

  async getAll(): Promise<BaseSavedSearch[]> {
    const data: MarketSavedSearchDto[] = await this.client.get("/");

    return data.map((d) => MarketMapper.dtoToModel(d));
  }

  async get(searchId: number): Promise<BaseSavedSearch> {
    const dto = await this.getOne(searchId);

    return MarketMapper.dtoToModel(dto);
  }

  async update(search: BaseSavedSearch): Promise<void> {
    const dto = await this.getOne(search.id);

    const updatedSavedSearch = MarketMapper.modelToUpdateDto(search, dto);

    await this.client.put("/", updatedSavedSearch);
  }

  async delete(searchId: number): Promise<void> {
    await this.client.delete(`/${searchId}`);
  }

  async create(
    name: string,
    notifications: NotificationChannels,
    metadata: SavedSearchInput
  ): Promise<number> {
    const savedSearch = MarketMapper.modelToCreateDto(
      { name, notifications },
      metadata
    );

    return this.client.post("/", savedSearch);
  }

  private async getOne(searchId: number): Promise<MarketSavedSearchDto> {
    const data: MarketSavedSearchDto[] = await this.client.get(`/${searchId}`);

    const dto = data.find((search) => search.id === searchId);

    if (!dto) {
      throw new Error(`Failed to find the saved search ${searchId}`);
    }

    return dto;
  }
}
